import { getEnvironment } from "./env.util";
export const API_URL =
  getEnvironment() === "staging"
    ? "https://staging-api.cpe.asu.edu/v1/cpe/"
    : "https://api.cpe.asu.edu/v1/cpe/";
export default API_URL;
